import { createSelector } from '@reduxjs/toolkit';

const search = (state) => state?.search;

const recentlyStoreSearchedSelector = createSelector(
  search,
  (state) => state.recentlySearched,
);
const selectReservationRecentSearch = createSelector(
  search,
  (state) => state.recentlyReservationSearched,
);

export { recentlyStoreSearchedSelector, selectReservationRecentSearch };
